import HintComponent from '../../global-search/components/global-not-found-hint';
import React, { FC, useEffect, useRef } from 'react';
import styled from '@emotion/styled';
import { ContentContainerPageHeader } from '../../../layout/container';
import { mediaQueries } from '../../../styles/media-queries';
import { useTranslation } from 'next-i18next';

const NotFoundHint: FC = () => {
  const [t] = useTranslation('search-component');
  const hintRef = useRef<HTMLElement>(null);

  useEffect(() => {
    let timeout: NodeJS.Timeout;

    const onScroll = function (): void {
      timeout = setTimeout(() => {
        if (0 < window.scrollY) {
          hintRef.current?.classList.add('hidden');
        } else {
          hintRef.current?.classList.remove('hidden');
        }
      }, 300);
    };

    document.addEventListener('scroll', onScroll);

    return (): void => {
      clearTimeout(timeout);
      document.removeEventListener('scroll', onScroll);
    };
  }, []);

  return (
    <NotFoundHintWrapper ref={hintRef}>
      <HintComponent text={t('hint-not-available-product')}/>
    </NotFoundHintWrapper>
  );
};

const NotFoundHintWrapper = styled(ContentContainerPageHeader)`
  position: absolute;
  visibility: visible;
  transition: visibility 300ms linear 0s, opacity 300ms;
  top: 100px;
  right: auto;
  left: 10vw;
  transform: none;

  &.hidden {
    opacity: 0;
    visibility: hidden;
  }

  @media ${mediaQueries.tablet} {
    top: 80px;
  }

  @media ${mediaQueries.laptop} {
    display: unset;
    width: 365px;
    left: 25vw;
  }

  @media ${mediaQueries.desktop} {
    left: 50%;
    transform: translateX(-390px);
  }
`;

export default React.memo(NotFoundHint, () => true);
